import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const HowToSeries = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "How to Series?";

  const title = "How to Series?";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> How to Series? | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="How to Series? | Money Service Business Advocacy UK "
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/learning-hub">Learning Hub</NavLink>
              </li>
              <li className="active">
                <a href="#!">How to Series?</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row justify-content-start">
              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-conduct-ml-and-tf-risk-assessment.png"
                      alt="How to Conduct ML and TF Risk Assessment for Your Business?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-conduct-ml-and-tf-risk-assessment">
                          How to Conduct ML and TF Risk Assessment for Your
                          Business?
                        </NavLink>
                      </h3>
                      <p>
                        As a Money Service Business (MSB) in the UK, conducting
                        an Money Laundering (ML) and Terrorist Financing (TF)
                        risk assessment...
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/how-to-conduct-ml-and-tf-risk-assessment"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-comply-with-fca-consumer-duty.png"
                      alt="How to Comply with FCA Consumer Duty?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-comply-with-fca-consumer-duty">
                          How to Comply with FCA Consumer Duty?
                        </NavLink>
                      </h3>
                      <p>
                        As a Money Service Business (MSB) in the UK, it is
                        crucial to comply with the Financial Conduct Authority
                        (FCA) Consumer Duty.
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/how-to-comply-with-fca-consumer-duty"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-prepare-for-an-hmrc-audit.png"
                      alt=" How to Prepare for an HMRC Audit?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-prepare-for-an-hmrc-audit">
                          How to Prepare for an HMRC Audit?
                        </NavLink>
                      </h3>
                      <p>
                        HMRC may carry out a compliance check—either through a visit or an office-based review. The goal is to ensure you are complying with your legal...
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/how-to-prepare-for-an-hmrc-audit"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-start-a-currency-exchange-bureau.png"
                      alt="How to Start a Currency Exchange Bureau?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-start-a-currency-exchange-bureau">
                         How to Start a Currency Exchange Bureau?
                        </NavLink>
                      </h3>
                      <p>
                        Starting a currency exchange bureau can be a lucrative business opportunity. This guide outlines the essential steps to establish your bureau.
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/how-to-start-a-currency-exchange-bureau"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-stay-compliant-with-regdata-submissions.png"
                      alt="How to Stay Compliant with RegData Submissions?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-stay-compliant-with-regdata-submissions">
                         How to Stay Compliant with RegData Submissions?
                        </NavLink>
                      </h3>
                      <p>
                        Staying compliant with RegData submissions is essential for all firms regulated by the Financial Conduct Authority (FCA).
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/how-to-stay-compliant-with-regdata-submissions"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/how-to-series/how-to-renew-hmrc-mlr.png"
                      alt="How to Renew HMRC MLR?"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <h3>
                        <NavLink to="/how-to-renew-hmrc-mlr">
                         How to Renew HMRC MLR?
                        </NavLink>
                      </h3>
                      <p>
                        Renewing your Money Laundering Regulations (MLR) registration with HMRC is crucial for compliance if the renewal date is passed you are not allowed to trade till new registration is received.
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart mt-4">
                      <NavLink
                        to="/how-to-renew-hmrc-mlr"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HowToSeries;
